import React, { Fragment, useState, useEffect } from 'react';
import moment from 'moment';
// store
import { authService } from "../../../../store/services/ServiceAuth";
import { paymentService } from "../../../../store/services/ServicePayment";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import Loading from "../../../../components/others/Loading";
import { Form, Button, Grid, /*Card,*/ Divider } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import StornoRecordsTable from './StornoRecordsTable';

const Storno = () => {
    authService.useIsAdmin();

    const [isLoading, setIsLoading] = useState(true)
    const [filters, setFilters] = useState({
        from: moment().startOf('month').format("DD.MM.YYYY"),
        to: moment().endOf('month').format("DD.MM.YYYY"),
    })
    const [records, setRecords] = useState([])
    // eslint-disable-next-line
    const [view, setView] = useState(1)

    async function fetchRecords() {
        setIsLoading(true);

        let params = "?q="
        if (filters.from) params += `&from=${moment(filters.from, "DD.MM.YYYY").format("YYYY-MM-DD")}`
        if (filters.to) params += `&to=${moment(filters.to, "DD.MM.YYYY").format("YYYY-MM-DD")}`

        const request = await paymentService.getStornos(params)

        if (request.status === 200) {
            setRecords(request.response)
        }

        setIsLoading(false);
    }

    const handleFilter = async () => {
        fetchRecords()
    }

    useEffect(() => {
        fetchRecords()
        // eslint-disable-next-line
    }, [view])

    return (
        <Fragment>
            <HeaderTitle title="Prehľad refundácií" />
            <section>
                <Grid>
                    <Grid.Row style={{ paddingBottom: 0 }}>
                        <Grid.Column computer={8} tablet={16} mobile={16} >
                            <Form onSubmit={handleFilter}>
                                <Form.Group widths="equal">
                                    <DateInput
                                        fluid
                                        clearable
                                        localization="sk"
                                        label="Dátum od"
                                        placeholder="DD.MM.YYYY"
                                        dateFormat="DD.MM.YYYY"
                                        value={filters.from}
                                        onChange={(e, { value }) => setFilters({ ...filters, from: value })}
                                        iconPosition="right"
                                        animation="none"
                                        closable
                                        hideMobileKeyboard
                                    />
                                    <DateInput
                                        fluid
                                        clearable
                                        localization="sk"
                                        label="Dátum do"
                                        placeholder="DD.MM.YYYY"
                                        dateFormat="DD.MM.YYYY"
                                        value={filters.to}
                                        onChange={(e, { value }) => setFilters({ ...filters, to: value })}
                                        iconPosition="right"
                                        animation="none"
                                        closable
                                        hideMobileKeyboard
                                    />

                                    <Form.Field style={{ marginTop: "1.8rem" }}>
                                        <Button disabled={isLoading || (filters.from === "" || filters.to === "")} style={{ background: "var(--primary)", color: "var(--white)" }}>Potvrdiť</Button>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                {isLoading
                    ? <Loading />
                    :
                    <>

                        <Divider />
                        <StornoRecordsTable records={records} />
                    </>
                }
            </section>
        </Fragment>
    );
};

export default Storno;